// import FixedConfigForm from "./fixed";
// import HourlyConfigForm from "./forms/hourly";
// import RecurringConfigForm from "./recurring";

import DedicatedConfigForm from "@/modules/work/jobs/config/dedicated/form";
import { EvtHeader } from "components/header";
import BucketConfigForm from "@/modules/work/jobs/config/bucket/form";
import FixedConfigForm from "@/modules/work/jobs/config/fixed/form";
import HourlyConfigForm from "@/modules/work/jobs/config/hourly/form";
import RecurringConfigForm from "@/modules/work/jobs/config/recurring/form";
import { useJob } from "@/modules/work/jobs/context";

const JobConfig = () => {
  const { type, config } = useJob();

  const renderConfigForm = () => {
    switch (type) {
      case "fixed":
        return <FixedConfigForm config={config} />;
      case "hourly":
        return <HourlyConfigForm config={config} />;
      case "dedicated":
        return <DedicatedConfigForm config={config} />;
      case "recurring":
        return <RecurringConfigForm config={config} />;
      case "bucket":
        return <BucketConfigForm config={config} />;
      default:
        return null;
    }
  };

  return (
    <div>
      <EvtHeader title="Config" />
      {renderConfigForm()}
    </div>
  );
};

export default JobConfig;
